module.exports = __webpack_public_path__ + "static/beauty6-8ba8edb1e65824dbfb22da9cfa6a624b.jpg";